export default __webpack_public_path__ + "static/media/drop-down-arrow.2b74fbb7.svg";